export default "__VITE_ASSET__f865391f__"